import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      const { fallback } = this.props
      if (typeof fallback === 'function') return fallback(this.state.error)
      if (fallback) return fallback

      return (
        <div style={{
          padding: 24,
          color: 'var(--text-primary)',
          background: 'var(--bg-secondary)',
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--border-base)',
          textAlign: 'center',
        }}>
          <h3 style={{ marginBottom: 8 }}>Something went wrong</h3>
          <p style={{ color: 'var(--text-secondary)' }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
        </div>
      )
    }
    return this.props.children
  }
}
